/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   CarouselV3ControlsDefaults.tsx
 */
import { Box, Button, ButtonProps, useTheme } from '@chakra-ui/react'
import { ChevronLeft, ChevronRight } from '@zcode-ui/icons'
import React from 'react'

import 'react-multi-carousel/lib/styles.css'
import { ProgressDots } from '../ProgressDots'
import { CAROUSEL_ARROW_CLASS } from '../constants'
import { LeftArrowProps, ProgressDotProps, RightArrowProps } from '../types'

import { nextSlide, previousSlide } from './helpers'

export const buttonRound: ButtonProps = {
  borderRadius: '100%',
  bg: 'gray.150',
  padding: 0,
  width: 6,
  height: 6,
  margin: 0,
  minWidth: 6,
  opacity: 0,
  zIndex: 1,
  alignSelf: 'center',
  transition: 'opacity 300ms ease-in',
  _hover: {
    background: 'gray.50',
  },
}

export const LeftArrowDefault = ({
  currentSlide,
  goToSlide,
  previous,
  totalItems,
}: LeftArrowProps) => {
  const { colors } = useTheme()

  return (
    <Box left="16px" position="absolute" top="50%" transform="translateY(-50%)">
      <Button
        aria-label="Previous Item"
        className={CAROUSEL_ARROW_CLASS}
        onClick={previousSlide(currentSlide, totalItems, goToSlide, previous)}
        {...buttonRound}
      >
        <ChevronLeft fill={colors.blackAlpha['900']} style={{ marginLeft: '2px' }} />
      </Button>
    </Box>
  )
}

export const RightArrowDefault = ({
  currentSlide,
  goToSlide,
  next,
  totalItems,
}: RightArrowProps) => {
  const { colors } = useTheme()

  return (
    <Box position="absolute" right="16px" top="50%" transform="translateY(-50%)">
      <Button
        aria-label="Next Item"
        className={CAROUSEL_ARROW_CLASS}
        onClick={nextSlide(currentSlide, totalItems, goToSlide, next)}
        {...buttonRound}
      >
        <ChevronRight fill={colors.blackAlpha['900']} style={{ marginRight: '2px' }} />
      </Button>
    </Box>
  )
}

export const ProgressDotsDefault = ({
  totalItems,
  isMobile,
  maxDots,
  goToSlide,
  currentSlide,
}: ProgressDotProps) => {
  return (
    <Box bottom="3" left="50%" position="absolute" transform="translateX(-50%)">
      <ProgressDots
        currentSlide={currentSlide}
        goToSlide={goToSlide}
        isMobile={isMobile}
        maxDots={maxDots}
        totalItems={totalItems}
      />
    </Box>
  )
}
